// Fires to both GA4 (gtag) and Google Tag Manager (dataLayer). Never throws.
export const gaEvent = (name, params = {}) => {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  } catch (_) { /* analytics must never break the app */ }
};

// Standard conversion events — keep names stable, GTM triggers depend on them.
const LINKEDIN_FOUNDER_SIGNUP_CONVERSION_ID = 31910953;

export const trackSignUp = (method, extra = {}) => {
  const params = { method, role: "founder", ...extra };
  gaEvent("sign_up", params);
  if (params.role === "founder") linkedInConversion(LINKEDIN_FOUNDER_SIGNUP_CONVERSION_ID);
};

export const linkedInConversion = (conversionId) => {
  try {
    if (typeof window !== "undefined" && typeof window.lintrk === "function") {
      window.lintrk("track", { conversion_id: conversionId });
    }
  } catch (_) { /* ignore */ }
};

export const trackScoreComplete = (score, extra = {}) =>
  gaEvent("score_complete", { score: score ?? undefined, ...extra });

export const trackPurchase = (poll, extra = {}) => {
  if (!poll || poll.payment_status !== "paid") return;
  gaEvent("purchase", {
    transaction_id: poll.reference || poll.session_id,
    value: poll.amount ?? undefined,
    currency: (poll.currency || "kes").toUpperCase(),
    items: [{ item_id: poll.tier || "readiness_report", item_name: extra.report || "Capital Readiness Report", quantity: 1, price: poll.amount ?? undefined }],
    ...extra,
  });
};
